<template lang="pug">
  div(data-testid="attachment-block")
    p.lead
      i.fa.fa-fw.fa-paperclip
      |
      |
      span 添付ファイル
      a.btn.btn-success.btn-sm.pull-right(title="追加" @click.prevent="addItem" data-testid="-btn-add")
        span.glyphicon.glyphicon-plus

    p.text-info ※ {{`1 ファイル につき ${$store.getState('attachment_max_size')} MB までのファイルをアップロードできます。`}}
    app-messages(:errorMessages="errmsgs")
    .bcard-table-list-container(ref="files")
      .panel.panel-default(v-if="attachCount > 0")
        .table-responsive.bcard-table-container.-height-auto.bcard-card-details-table
          table.table.table-striped.table-bordered.bcard-table
            thead.bcard-card-details-file-item
              tr
                th.bcard-card-details-td-file-openflag 公開区分
                th.bcard-card-details-td-file-title タイトル
                  |
                  |
                  span.bcard-required (*)
                th.bcard-card-details-td-file-name ファイル名
                  |
                  |
                  span.bcard-required (*)
                th.bcard-card-details-td-file-size サイズ
                th.bcard-card-details-td-btns
            tbody.bcard-card-details-file-item
              template(v-for="(attachment, index) in attachments")
                tr(v-if="attachments[index].isDeleted === false")
                  td
                    div
                      .radio.radio-rich
                        label(data-testid="-radio-public")
                          input#_bcard_card_input_public-1(type="radio" :value="app_flag.ON" :name="'person[attachments][' + index + '][openflag]'" v-model="attachments[index].openflag")
                          span
                            i.fa.fa-dot-circle-o.fa-lg
                          i.fa.bcard-fa-person-public(title="公開")
                          | &nbsp;公開
                      .radio.radio-rich
                        label(data-testid="-radio-secret")
                          input#_bcard_card_input_public-0(type="radio" :value="app_flag.OFF" :name="'person[attachments][' + index + '][openflag]'" v-model="attachments[index].openflag")
                          span
                            i.fa.fa-dot-circle-o.fa-lg
                          i.fa.bcard-fa-person-private(title="非公開")
                          | &nbsp;非公開
                  td
                    input.form-control(type="text" :name="'person[attachments][' + index + '][title]'" :maxlength="maxlengths.title" v-model="attachments[index].title" required data-testid="-input-file-title")
                  td(v-if="attachments[index].isResetting === false")
                    input(@change="changeFile($event, index)" type="file" :name="'person[attachments][' + index + '][file]'" required data-testid="-input-file-name")
                  td.bcard-ui-userdata(style="text-align:right")
                    | {{attachments[index]['formatted_size']}}
                  td.bcard-card-details-td-btns
                    a.btn.btn-danger.btn-xs(@click.prevent="removeItem(index)" title="取り消し" data-testid="-btn-delete-file")
                      i.fa.fa-times.fa-fw
</template>

<script>
import AppMessages from '@/components/molecules/AppMessages'

export default {
  name: 'AttachmentsList',
  components: { AppMessages },
  props: {
  },
  data: function () {
    return {
      attachments: [], // 添付情報一覧
      attachCount: 0, // 削除されていない添付の数
      errmsgs: [], // エラーメッセージ
      maxlengths: {}
    }
  },
  created: function () {
    this.maxlengths = this.loadMaxlengths('Attachments')
  },
  methods: {
    addItem: function () {
      this.attachments.push({
        'openflag': this.app_flag.ON,
        'title': '',
        'filename': '',
        'size': '',
        'formatted_size': '',
        'isResetting': false,
        'isDeleted': false
      })
      this.attachCount++
    },
    changeFile: function (event, index) {
      const file = event.target.files[0]
      this.errmsgs = []
      let tmpName = ''
      let tmpSize = ''
      let tmpSizeShow = ''
      if (file !== undefined) {
        // ファイルサイズチェック
        const message = this.checkFileSize(file, this.$store.getState('attachment_max_size') * 1024 * 1024, true)
        if (message) {
          // input fileの内容を空にする
          // 参考URL https://qiita.com/yoko0180/items/653cf08d60f6d5213416
          // 一旦input fileのある箇所をv-ifで非表示にしてから再度表示して、内容を初期化する
          this.attachments[index].isResetting = true
          // @changeの処理終了後に実行
          this.$nextTick(function () {
            this.attachments[index].isResetting = false
          })
          // エラーメッセージを設定する
          this.errmsgs.push(message)
        }
        else {
          // 確認時に表示するファイル名とサイズを更新する
          tmpName = file.name
          tmpSize = file.size
          tmpSizeShow = this.convertUnit(file.size)
        }
      }

      // ファイルキャンセルとサイズチェックに引っかかった場合は、空の値が入る
      this.attachments[index].filename = tmpName
      this.attachments[index].size = tmpSize
      this.attachments[index].formatted_size = tmpSizeShow
    },
    removeItem: function (index) {
      // 内部変数の項目に、削除フラグを付ける
      this.attachments[index].isDeleted = true
      this.attachCount--
    }
  }
}
</script>

<style lang="scss" scoped>
.bcard-card-details-file-item {
  th,
  td {
    vertical-align: middle;
  }
  .bcard-card-details-td-file-openflag {
    width: 8em;
  }
  .bcard-card-details-td-file-title {
    width: 180px;
  }
  .bcard-card-details-td-file-name {
    width: 270px;
  }
  .bcard-card-details-td-file-size {
    width: 9em;
  }
  .bcard-card-details-td-btns {
    width: 45px;
    text-align: center;
  }
  input[type="file"] {
    width:100%
  }
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/forms/AttachmentsListForm.vue